<template>
    <div class="main situation">
        <div style="height: 100%">
            <div class="leftContent">
                <el-collapse v-model="activeNamesFirst">
                    <el-collapse-item title="单位信息" name="1">
                        <el-form ref="unitData" :model="unitData" :rules="rules">
                            <div class="tableContent">
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div>所属区域</div>
                                            </div>
                                            <div class="right h32">
                                                <el-select placeholder="请选择" v-model="unitData.provinceId">
                                                    <el-option v-for="item in provinceList" :key="item.id" :label="item.areaName" :value="item.id"></el-option>
                                                </el-select>
                                                <el-select placeholder="请选择" v-model="unitData.cityId" @change="onSelectCity">
                                                    <el-option v-for="item in cityList" :key="item.id" :label="item.areaName" :value="item.id"></el-option>
                                                </el-select>
                                                <el-select placeholder="请选择" v-model="unitData.areaId" @change="onSelectArea">
                                                    <el-option v-for="item in areaList" :key="item.id" :label="item.areaName" :value="item.id"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div><i class="required">*</i>单位全称</div>
                                            </div>
                                            <div class="right h32">
                                                <el-form-item prop="fullName">
                                                    <el-input placeholder="请输入单位全称" v-model="unitData.fullName"></el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div><i class="required">*</i>单位简称</div>
                                            </div>
                                            <div class="right h32">
                                                <el-form-item prop="simpName">
                                                    <el-input placeholder="请输入单位简称" v-model="unitData.simpName"></el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div><i class="required">*</i>组织机构编码</div>
                                            </div>
                                            <div class="right h32">
                                                <el-form-item prop="organizationCode">
                                                    <el-input placeholder="请输入组织机构编码" v-model="unitData.organizationCode"></el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div>报警编号前缀</div>
                                            </div>
                                            <div class="right h32">
                                                <input class="input" type="text" placeholder="请输入报警编号前缀" v-model="unitData.accidentNoPrefix" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div>排序号</div>
                                            </div>
                                            <div class="right h32">
                                                <input class="input" type="text" placeholder="请输入排序号" v-model="unitData.indexNo" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div>音视频能力</div>
                                            </div>
                                            <div class="right h32">
                                                <el-select placeholder="请选择" v-model="unitData.trtcStatus">
                                                    <el-option v-for="item in optionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div>预约状态</div>
                                            </div>
                                            <div class="right h32">
                                                <el-select placeholder="请选择" v-model="unitData.bookingStatus">
                                                    <el-option v-for="item in optionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div>支付二维码状态</div>
                                            </div>
                                            <div class="right h32">
                                                <el-select placeholder="请选择" v-model="unitData.payqrStatus">
                                                    <el-option v-for="item in optionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div>pc创建预约单</div>
                                            </div>
                                            <div class="right h32">
                                                <el-select placeholder="请选择" v-model="unitData.pcCreateStatus">
                                                    <el-option v-for="item in optionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div>发送短信</div>
                                            </div>
                                            <div class="right h32">
                                                <el-select placeholder="请选择" v-model="unitData.sendSmsStatus">
                                                    <el-option v-for="item in optionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div>全时段</div>
                                            </div>
                                            <div class="right h32">
                                                <el-select placeholder="请选择" v-model="unitData.allTimeModifyStatus">
                                                    <el-option v-for="item in optionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-49">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div>半身照必填</div>
                                            </div>
                                            <div class="right h32">
                                                <el-select placeholder="请选择" v-model="unitData.halfBodyPhotoStatus">
                                                    <el-option v-for="item in optionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-item h-100">
                                    <div class="row">
                                        <div class="column">
                                            <div class="left">
                                                <div>备注</div>
                                            </div>
                                            <div class="right h32">
                                                <el-input type="textarea" placeholder="请输入备注" v-model="unitData.desc" maxlength="120" resize="none" show-word-limit>
                                                </el-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </el-collapse-item>
                </el-collapse>
                <el-collapse v-model="activeNamesThird">
                    <el-collapse-item title="图章上传" name="1">
                        <div class="wholeAcccindentClass">
                            <div class="accidentImages">
                                <div class="images">
                                    <div class="img-box">
                                        <div v-if="unitData.stampUrl" style="width:100%;height:100%;">
                                            <div class="video-wrap" v-if="/(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(unitData.stampUrl)">
                                                <i></i>
                                            </div>
                                            <img :src="getImageUrl(unitData.stampUrl,'')" alt="" @click="previewImg(unitData.stampUrl)" />
                                        </div>
                                        <div class="img-mask-no" v-else>
                                            <i class="el-icon-upload" v-if="!unitData.stampUrl"></i>
                                            <i class="el-icon-zoom-in" @click="previewImg(unitData.stampUrl)" v-else></i>
                                            <div v-if="!unitData.stampUrl">上传图片</div>
                                        </div>
                                    </div>
                                    <el-upload ref="upload" class="upload-demo" :action="action" :auto-upload="false" :headers="headers" :show-file-list="false" :on-change="handleChange" :before-upload="beforeAvatarUpload" :on-success="uploadSuccess">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                    </el-upload>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <el-collapse v-model="activeNamesFourth">
                    <!--<el-collapse-item title="水印上传" name="1">
                        <div class="wholeAcccindentClass">
                            <div class="accidentImages">
                                <div class="images">
                                    <el-upload ref="uploadImg" action="#" :http-request="uploadMark" list-type="picture-card" :show-file-list="false" :before-upload="beforeAvatarUpload">
                                        <i v-if="!unitData.watermarkUrl" class="el-icon-upload">
                                        </i>
                                        <img v-if="unitData.watermarkUrl" :src="unitData.watermarkUrl" class="avatar" />
                                    </el-upload>

                                    <el-button size="small" type="primary" @click="uploadImgFn('mark')">点击上传</el-button>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>-->
                    <el-collapse-item title="水印上传" name="1">
                        <div class="wholeAcccindentClass">
                            <div class="accidentImages">
                                <div class="images">
                                    <div class="img-box">
                                        <div v-if="unitData.watermarkUrl" style="width:100%;height:100%;">
                                            <div class="video-wrap" v-if="/(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(unitData.watermarkUrl)">
                                                <i></i>
                                            </div>
                                            <img :src="getImageUrl(unitData.watermarkUrl,1)" alt="" @click="previewImg(unitData.watermarkUrl)" />
                                        </div>
                                        <div class="img-mask-no" v-else>
                                            <i class="el-icon-upload" v-if="!unitData.watermarkUrl"></i>
                                            <i class="el-icon-zoom-in" @click="previewImg(unitData.watermarkUrl)" v-else></i>
                                            <div v-if="!unitData.watermarkUrl">上传图片</div>
                                        </div>
                                    </div>
                                    <el-upload ref="uploadMark" class="upload-demo" :action="actionWatermarkUrl" :auto-upload="false" :headers="headers" :show-file-list="false" :on-change="handleChangeMark" :before-upload="beforeAvatarUpload" :on-success="uploadSuccessMark">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                    </el-upload>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <div class="bottomBtns">
            <el-button @click="saveUnitData('unitData')" type="primary">保存</el-button>
            <el-button @click="closeMask" plain>返回</el-button>
        </div>
    </div>
</template>

<script>
import config from "@/common/env.js";

export default {
    name: 'claim-detail',
    props: {
        detailShow: true,
        unitData: null
    },
    components: {
        
    },
    data() {
        return {
            headers: {
                "TR-TOKEN": JSON.parse(localStorage.getItem('userinfos')).token
            },
            action: '',
            actionWatermarkUrl: '',
            activeNamesFirst: ['1'],
            activeNamesThird: ['1'],
            activeNamesFourth: ['1'],
            // 必填验证
            rules: {
                fullName: [{
                    required: true,
                    message: '该项内容不能为空',
                    trigger: 'blur',
                }],
                simpName: [{
                    required: true,
                    message: '该项内容不能为空',
                    trigger: 'blur',
                }],
                organizationCode: [{
                    required: true,
                    message: '该项内容不能为空',
                    trigger: 'blur',
                }]
            },
            
            optionList: [
                {id: 0, name: "关闭", state: false},
                {id: 1, name: "开启", state: true},
            ],
            provinceCode: null,
			provinceList: [],
			cityCode: null,
			cityList: [],
			areaList: [],

        }
    },
    created() {
        console.log(this.unitData)
        this.getProvinceList();
    },
    mounted() {
        this.action = this.CODE_SERVER + '/admin/user/uploadFile'; //图片上传地址
        this.actionWatermarkUrl = this.CODE_SERVER + '/admin/user/no/uploadFile';
        
    },
    beforeDestroy() {
        localStorage.removeItem('single');
    },
    methods: {
        getImageUrl(url, type) {
            let str = type ? "/file/server/file" : "/file/server/decrypt/file";
            return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
        },
        handleChange(file) {
            console.log(file)
            this.$refs.upload.submit();
        },
        handleChangeMark(file) {
            console.log('file',file)
            this.$refs.uploadMark.submit();
        },
        uploadSuccess(res, file) {
            if (res.data) {
                this.unitData.stampUrl = res.data.imgUrl;
                this.unitData.url = res.data.url;
            }
        },
        uploadSuccessMark(res, file) {
            if (res.data) {
                // this.unitData.watermarkUrl = res.data.imgUrl;
                this.$set(this.unitData, 'watermarkUrl', res.data.imgUrl);
            }
        },
        // 点击上传图片按钮
        uploadImgFn(arg) {
            if (arg) {
                this.$refs.uploadImg.$children[1].handleClick();
            } else {
                this.$refs.uploadImg.$children[0].handleClick();
            }
        },
        closeMask() {
            this.$emit('detailShowData', false);
        },
        
        
        previewImg(url) {
            let that = this;
            if (this.$store.state.previewImgUrl) {
                this.$store.commit("SHOW_PREVIEW_IMG", '');
            }
            let data = [];
            if(this.unitData.stampUrl){
                data.push(this.unitData.stampUrl);
            }
            if(this.unitData.watermarkUrl){
                localStorage.setItem('single', 1);
                data.push(this.unitData.watermarkUrl);
            }
            let myIndex = data.findIndex(res=>res==url);
            setTimeout(() => {
                localStorage.setItem('myIndex', myIndex);
                localStorage.setItem('myPics', JSON.stringify(data));
                that.$store.commit('SHOW_PREVIEW_IMG', url);
            }, 1000);
        },

        // 获取省市区三联数据
        getProvinceList() {
			this.$axios.get(`/admin/organization/areaList/1/all`).then(res => {
				let datas = this.AppUtils.checkResponse(res);
				let { code, data, msg } = datas;
				if(code == 0) {
					data.map(item => {
						item.areaCode = parseFloat(item.areaCode);
					})
					this.provinceCode = parseFloat(data[0].areaCode);
					this.provinceList = data;
                    this.unitData.provinceId = data[0].id;
                    this.unitData.provinceName = data[0].areaName;
					this.getCityList(this.provinceCode);
				}
			})
		},
        getCityList(id) {
			this.$axios.get(`/admin/organization/areaList/2/${id}`).then(res => {
				let datas = this.AppUtils.checkResponse(res);
				let { code, data, msg } = datas;
				if(code == 0) {
					data.map(item => {
						item.areaCode = parseFloat(item.areaCode);
					})
					this.cityList = data;

                    if(this.unitData && this.unitData.cityId) {
                        this.cityList.map(item => {
                            if(item.id == this.unitData.cityId) {
                                this.cityCode = item.areaCode;
                                this.getAreaList(this.cityCode);
                            }
                        })
                    }
				}
			})
		},
		getAreaList(id) {
			this.$axios.get(`/admin/organization/areaList/3/${id}`).then(res => {
				let datas = this.AppUtils.checkResponse(res);
				let { code, data, msg } = datas;
				if(code == 0) {
					data.map(item => {
						item.areaCode = parseFloat(item.areaCode);
					})
                    let arr = [
                        {id: 0, areaName: "全部"}
                    ] 
					this.areaList = arr.concat(data);
				}
			})
		},
		onSelectCity(e) {
			// console.log(e)
            // console.log(this.cityList)
            this.unitData.areaId = null;
            this.unitData.areaName = null;
            this.cityList.map(item => {
                if(item.id == e) {
                    this.unitData.cityId = item.id;
                    this.unitData.cityName = item.areaName;
                    this.cityCode = item.areaCode;
                    this.getAreaList(this.cityCode);
                }
            })
		},
        onSelectArea(e) {
            this.areaList.map(item => {
                if(item.id == e) {
                    this.unitData.areaId = item.id;
                    this.unitData.areaName = item.areaName;
                }
            })
        },
        
        // 图片限制和提示
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/jpg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传图片只支持jpg、jpeg、png格式!');
            }
            if (!isLt2M) {
                this.$message.error('图片大小不能超过2MB！');
            }
            return isJPG && isLt2M;
        },
        // 自定义图片上传
        upload(fileObj) {
            const formData = new FormData();
            formData.append('file', fileObj.file);
            formData.append('type', fileObj.file.type);
            this.$axios.request({
                url: '/admin/user/uploadFile',
                method: 'post',
                data: formData
            }).then(res => {
                if (res) {
                    this.unitData.stampUrl = res.data.data.imgUrl;
                    this.unitData.url = res.data.data.url;
                }
            })
        },
        //水印上传
        uploadMark(fileObj) {
            const formData = new FormData();
            formData.append('file', fileObj.file);
            formData.append('type', fileObj.file.type);
            this.$axios.request({
                url: '/admin/user/uploadFile',
                method: 'post',
                data: formData
            }).then(res => {
                if (res) {
                    this.unitData.watermarkUrl = res.data.data.imgUrl;
                }
            })
        },

        // 保存
        saveUnitData(formName) {
            console.log(this.unitData)
            let formData = {};
            if (!this.unitData.isNew) {
                formData.id = this.unitData.id;
            }
            formData.areaId = this.unitData.areaId;
            formData.areaName = this.unitData.areaName;
            formData.fullName = this.unitData.fullName;
            formData.simpName = this.unitData.simpName;
            formData.organizationCode = this.unitData.organizationCode;
            formData.accidentNoPrefix = this.unitData.accidentNoPrefix;
            formData.indexNo = this.unitData.indexNo;
            formData.desc = this.unitData.desc;
            formData.stampUrl = this.unitData.url;
            formData.watermarkUrl = this.unitData.watermarkUrl;

            formData.cityId = this.unitData.cityId;
            formData.cityName = this.unitData.cityName;
            formData.provinceId = this.unitData.provinceId;
            formData.provinceName = this.unitData.provinceName;
            formData.trtcStatus = this.unitData.trtcStatus;
            formData.bookingStatus = this.unitData.bookingStatus;
            formData.payqrStatus = this.unitData.payqrStatus;
            formData.pcCreateStatus = this.unitData.pcCreateStatus;
            formData.sendSmsStatus = this.unitData.sendSmsStatus;
            formData.allTimeModifyStatus = this.unitData.allTimeModifyStatus;
            formData.halfBodyPhotoStatus = this.unitData.halfBodyPhotoStatus
            formData.parentId = this.unitData.areaId == 0 ? this.unitData.provinceId : this.unitData.cityId;
            
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let url = this.unitData.isNew ? 'save' : 'edit' // 切换新建和保存接口地址
                    this.$axios.post('/admin/organization/' + url, formData).then(res => {
                        let data = this.AppUtils.checkResponse(res);
                        if (data) {
                            this.$emit('getUnitList');
                            this.$emit('detailShowData', false);
                            this.$message.success("保存成功");
                        }
                    })
                } else {
                    this.$message.error("必填内容不能为空");
                    return false
                }
            })
        },

    }
}
</script>

<style lang="scss" scoped>
.main {
    display: flex;
    background: #fff;
    flex-direction: row;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    z-index: 100;
    flex-direction: column;
    box-sizing: border-box;

    .maskTitle {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        /*position: fixed;*/
        /*top: 50px;*/
        justify-content: space-between;
        width: calc(100%);
        box-sizing: border-box;
        padding: 10px;
        background: #ccc;
        z-index: 100;
    }

    .leftContent {
        /*height: 100%;*/
        /*overflow-y: scroll;*/
        box-sizing: border-box;
        text-align: left;
        width: calc(100%);
        margin-right: 10px;
        float: left;
        padding-bottom: 50px;

        .tableContent {
            margin-top: 10px;
            border: 1px solid #f4f5f7;
        }

        .userImages {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-top: 20px;

            .img-box {
                margin-right: 10px;
                margin-bottom: 10px;
            }
        }

        .wholeAcccindentClass {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;

            .accidentImages {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .images {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    flex-direction: column;
                    height: 120px;
                    margin-top: 20px;
                    margin-right: 10px;
                    margin-bottom: 10px;

                    .img-box {
                        margin: 0 auto;
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }

    .personInfo {
        .title {
            line-height: 40px;
            background: #ccc;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0px 10px;
        }

        .wholePersonClass {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;

            .accidentImages {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .images {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    flex-direction: column;
                    height: 120px;
                    margin-top: 20px;
                    margin-right: 10px;
                    margin-bottom: 10px;

                    .img-box {
                        margin: 0 auto;
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }

    .bottomBtns {
        width: 100%;
        position: fixed;
        left: 0px;
        bottom: 0px;
        background: #ccc;
        margin-bottom: 0px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

// 修改默认样式
.el-form-item {
    margin-bottom: 0;

    .el-input {
        width: 200px;
    }

    .el-input+div {
        position: absolute;
        top: 30%;
        left: 210px;
    }

    /deep/.el-form-item__error {
        position: absolute;
        top: 30%;
        left: 210px;
    }
}

/deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

/deep/.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

/deep/.avatar-uploader,
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    text-align: center;
}

/deep/.avatar-uploader-icon svg {
    margin-top: 64px;
    /* (178px - 28px) / 2 - 1px */
}

/deep/.avatar {
    width: 145px;
    height: 145px;
    display: block;
}

.el-collapse-item__content {
    height: 200px !important;

    .el-button {
        margin-top: 10px;
    }
}

.wholeAcccindentClass .el-icon-zoom-in:before {
    content: none;
}
</style>



// WEBPACK FOOTER //
// detail.vue?c7c4aab2